/**
 * Formata valores numéricos com abreviação (K, M, B)
 * Ex: 6000 → "6K", 1500000 → "1,5M", 2500000000 → "2,5B"
 *
 * @param {number} value - Valor numérico
 * @param {boolean} isCurrency - Se true, adiciona prefixo "R$"
 * @returns {string} Valor formatado abreviado
 */
export const formatAbbrValue = (value, isCurrency = false) => {
  if (value == null || isNaN(value)) return isCurrency ? "R$ 0" : "0";

  const abs = Math.abs(value);
  let formatted;

  if (abs >= 1_000_000_000) {
    formatted = (value / 1_000_000_000).toFixed(1).replace(".", ",") + "B";
  } else if (abs >= 1_000_000) {
    formatted = (value / 1_000_000).toFixed(1).replace(".", ",") + "M";
  } else if (abs >= 1_000) {
    formatted = (value / 1_000).toFixed(1).replace(".", ",") + "K";
  } else {
    formatted = value.toLocaleString("pt-BR", {
      minimumFractionDigits: isCurrency ? 2 : 0,
      maximumFractionDigits: isCurrency ? 2 : 0,
    });
  }

  return isCurrency ? `R$ ${formatted}` : formatted;
};
